module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "chapter-number---IVP sigil_not_in_toc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagev",
      "title": "v"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("To")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Tabitha Kapic")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("You embody courage and love")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("I can’t thank God enough for you"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Jonathan and Margot Kapic")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("Your faith, joy, and forgiveness are precious gifts to us"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("& "), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("To those who have supported us so well, especially")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Our families and friends")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("The Covenant College community")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("New City Fellowship")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Lookout Mountain Presbyterian Church")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a1bb6fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/04_dedication.vue
// module id = 60
// module chunks = 0